import { render, staticRenderFns } from "./BirthdaySampleConfig.vue?vue&type=template&id=4ca74694&scoped=true"
import script from "./BirthdaySampleConfig.vue?vue&type=script&lang=js"
export * from "./BirthdaySampleConfig.vue?vue&type=script&lang=js"
import style0 from "./BirthdaySampleConfig.vue?vue&type=style&index=0&id=4ca74694&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca74694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca74694')) {
      api.createRecord('4ca74694', component.options)
    } else {
      api.reload('4ca74694', component.options)
    }
    module.hot.accept("./BirthdaySampleConfig.vue?vue&type=template&id=4ca74694&scoped=true", function () {
      api.rerender('4ca74694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/BirthdaySampleConfig.vue"
export default component.exports